module.exports = __webpack_public_path__ + "media/images/products/b3-8692b1a43c02d7b839b18c7c82e3edc9.png";